module.exports = __webpack_public_path__ + "static/media/Slide103.0f3ac9d7.jpg";